export default __webpack_public_path__ + "static/profile-pic-2021-6ef7072c44aea65c50f933ffba505e9f.png";